<template>
    <div class="history-list m-auto" data-cy="list_history_redeem">
        <div v-show="isHaveItem && isLoaded" data-cy="container_history_redeem_list">
            <HistoryItem
                    v-for="(campaign) in purchases"
                    :key="campaign.id"
                    :purchase="campaign"
                    @onClickPurchase="clickPurchase(campaign)"
            ></HistoryItem>
        </div>
        <div v-show="!isHaveItem && isLoaded">
            <Nodata
                :textData="lbl.no_data"
                :isTextOnly="true" />
        </div>
    </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import Locale from '@/helper/locale/Locale.js';
import ConfigManager from '@/config/ConfigManager.js';
import { CampaignType } from '@/helper/StaticValue.js';
//component
import HistoryItem from './HistoryItem.vue';
import Nodata from '@/components/Layout/Page/NoData.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
//service
import BzbsHistory from '@/core/History/service/BzbsHistory.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
//import { WebInterfaceController } from '@/module/Detail/controller/WebInterfaceController';
import PurchaseDeliveryModel from '@/core/History/model/PurchaseDeliveryModel.js';

export default {
    name: 'HistoryList',
    mixins: [ModalMixin, LocaleMixin],
    components: {
        HistoryItem,
        Nodata,
    },
    props: {
        listConfig:   { type: Object, required: true },
        filterConfig: { type: Object, required: true },
    },
    data: function() {
        return {
            purchases: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,

            isSerialLoading: false,
        };
    },
    methods: {
        //#region history list
        getList: function () {
            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsHistory.apiGetPurchase(this.listConfig, this.filterConfig).subscribe((purchases) => {
                    Util.log('history list', purchases);

                    this.listConfig.increstSkip();
                    //check is there are more campaign.
                    if (purchases && purchases.length < this.listConfig.defaultTopAmount) {
                        this.listConfig.setSeeMoreEnable(false);
                    }
                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                        this.purchases = [];
                    }

                    for (var purchase of purchases) {
                        //TODO: Add GA Tracking.
                        this.purchases.push(purchase);
                    }

                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = this.purchases.length > 0 ? true : false;
                    resolve();
                }, (err) => {
                    resolve();
                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = false;

                    if(err.id == 401){
                        this.$router.push('/error');
                    }else{
                        this.errorApi(err);
                    }
                });
            });
        },

        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) {
                return;
            }

            if (this.isLoading) {
                return;
            }
            this.getList();
        },
        //#endregion history list

        //#region action history
        clickPurchase: function (purchase) {
            console.log('purchase', purchase);
            this.tracking.event('history_my_reward', 'click_view_coupon', purchase.id, null);
            //check internet stuff.
            if (this.isSerialLoading) {
                return;
            }

            // this.clickedIndex = index;
            if (purchase.type === CampaignType.Interface) {
                this.openInterfaceHistory(purchase);
                return;
            }

            if(purchase.info2 && purchase.info2.toLowerCase() == 'startbucks'){
                // this.modal.freeStarbuckModal
                //     .clearModal()
                //     .setBgImg(purchase.fullImageUrl)
                //     .setSerial(purchase.serial)
                //     .setBtnOk(this.lbl.history.starbuck.btn_back)
                //     .show();
                this.modal.freeStarbuckModal
                    .clearModal()
                    .setPurchase(purchase)
                    .setBtnOk(this.lbl.history.starbuck.btn_back)
                    .show();

                this.modal.freeStarbuckModal.onClickOk(() =>{
                    window.location.reload();
                });

                return;
            }

            this.isSerialLoading = true;
            BzbsHistory.apiRedeemDetail(purchase.redeemKey).subscribe({
                next: (result) => {
                    this.isSerialLoading = false;
                    purchase.updateAfterRedeem(result);

                    if(purchase.delivered){
                        let purchaseDelivery = new PurchaseDeliveryModel(result);
                        console.log('purchaseDelivery', purchaseDelivery)
                        this.openDelivery(purchaseDelivery);
                    }else{
                        if (this.isShowSerialModal(purchase)) {
                            this.openSerial(purchase);
                        }
                    }

                    // TODO ถ้ามีไรแปลกๆ ก็เปิด comment นี้ได้ (Chat)
                    // else {
                    //     this.refreshList();
                    // }
                },
                error: (err) => {
                    this.isSerialLoading = false;
                    console.log(err);
                },
            });
        },

        openSerial: function(purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            console.log('purchase1', purchase)
            console.log('open serial');
            if(this.isVerifyCode(purchase) || this.isTypeFreeMarkUsed(purchase)
                || this.isTypeDealMarkUsed(purchase)){
                if(purchase.arrangedDate != null){
                    this.modal.serialModal
                        .clearModal()
                        .setSerial(serialModel)
                        .setIsStaff(true)
                        .setIsShowStaff(false)
                        .setIsUsed(true)
                        .show();
                }else{
                    if(!this.isExpired(purchase)){
                        this.modal.serialModal
                            .clearModal()
                            .setSerial(serialModel)
                            .setIsShowStaff(true)
                            .show();
                    }else{
                        this.modal.serialModal
                            .clearModal()
                            .setSerial(serialModel)
                            .setIsStaff(false)
                            .setIsShowStaff(false)
                            .show();
                    }
                }

            } else {
                this.modal.serialModal
                    .clearModal()
                    .setSerial(serialModel)
                    .show();
            }

            this.modal.serialModal.onClickForStaff(data => {
                if (data) {
                    BzbsHistory.apiRedeemArrange(data.redeemKey).subscribe({
                        next: (res) => {
                            console.log(res);
                        },
                        error: (err) => {
                            console.log('err',err);
                        },
                    })
                }
            });

            this.modal.serialModal.onCloseModal(() =>{
                window.location.reload();
            });

            this.modal.serialModal.onClickCoupon(() =>{
                window.location.reload();
            });

            this.modal.serialModal.onClickDetail(() =>{
                this.$router.push('/campaign/'+ purchase.id);
            });

            this.modal.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
                this.refreshList();
            });
        },

        openDelivery: function(purchase) {
            console.log('open delivery');
            this.modal.deliveryStatusModal
                    .clearModal()
                    .setSerial(purchase)
                    .show();
            // this.modal.serialModal.onSerialExpire(() => {
            //     purchase.setPurchaseExpired();
            //     this.refreshList();
            // });
        },

        openInterfaceHistory: function(purchase) {
            var sToken = Account.getTokenShuffle();
            var locale = Locale.getLocaleCode();
            var header = 'false';
            var theme = ConfigManager.getAppName();
            var returnUrl = encodeURIComponent(window.location.href);

            // new generation landing interface
            if (purchase.privilegeMessageFormat == 'link') {
                var url = purchase.privilegeMessage;

                url = url.replace('<campaign_id>', purchase.id);
                url = url.replace('<token>', sToken);
                url = url.replace('<serial>', purchase.serial);
                url = url.replace('<locale>', Locale.getLocaleCode());

                url += '&return_url=' + returnUrl;

                window.location.replace(url);
                return;
            }

            // let interfaceController = new WebInterfaceController(purchase);
            // let historyCount = interfaceController.getHistoryCount();

            returnUrl = window.location.href;
            // if (returnUrl.indexOf('?') != -1) {
            //     returnUrl = returnUrl + '?back=' + historyCount;
            // } else {
            //     returnUrl = returnUrl + '&back=' + historyCount;
            // }
            returnUrl = encodeURIComponent(returnUrl);

            // old default landing interface
            if (purchase.website && purchase.website.indexOf('starbucks') > 0) {
                let url = purchase.website +
                        '&token=' + sToken +
                        '&locale=' + locale +
                        '&RedeemKey=' + purchase.redeemKey +
                        '&header=' + header +
                        '&theme=' + theme +
                    '&return_url=' + returnUrl; // ReturnUrl;
                window.location = url;
            } else if (purchase.website && purchase.website.indexOf('linesticker') > 0) {
                let url = purchase.website
                        + "&info2=" + purchase.info2
                        + "&info3=" + purchase.info3
                        + "&locale=" + locale
                        + "&return_url=" + returnUrl
                        + "&token=" + sToken
                        + "&is_history=true";
                window.location = url;
            }
        },

        isShowSerialModal: function (purchase) {
            // if (purchase.serial === 'XXXXXXX') {
            //     return false;
            // }
            // if (purchase.expireIn && purchase.expireIn <= 0) {
            //     return false;
            // }

            if (purchase.type === CampaignType.Interface) {
                if (purchase.pointType === "get")
                    return false;

                return true;
            }

            if (purchase.type === CampaignType.Free ||
                purchase.type === CampaignType.Deal ||
                purchase.type === CampaignType.Buy) {
                if (purchase.delivered) {
                    return false;
                }
            }

            if (purchase.type === CampaignType.Draw) {
                return false;
            }

            return true;
        },

        refreshList: function () {
            var tmp = this.purchases;
            this.purchases = [];

            this.$nextTick().then( () => {
                this.purchases = tmp;
            });
        },

        isVerifyCode: function(purchase){
            return (purchase.type === CampaignType.VerifyCode);
            //return (purchase.privilegeMessage && purchase.privilegeMessage.toLowerCase() == 'mark use');
        },

        isTypeFreeMarkUsed: function(purchase){
            return (purchase.type === CampaignType.Free && purchase.privilegeMessage && purchase.privilegeMessage.toLowerCase() == 'mark use');
        },

        isTypeDealMarkUsed: function(purchase){
            return (purchase.type === CampaignType.Deal && purchase.privilegeMessage && purchase.privilegeMessage.toLowerCase() == 'mark use');
        },

        isExpired: function(purchase){
            if (purchase.serial === 'XXXXXXX') {
                return true;
            }
            // if (purchase.expireIn && purchase.expireIn <= 0) {
            //     return true;
            // }
            if (purchase.minutesValidAfterUsed > 0 && purchase.expireIn <= 0) {
                return true;
            }

            return false;
        }
        //#endregion action history
    },
}
</script>
<style lang="scss" scoped>
    .history-list {
        max-width: 500px;
    }
</style>
